/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Email_LabelInputs */

const en_feedback_email_label = /** @type {(inputs: Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email, if you want an answer`)
};

const zh_hans1_feedback_email_label = /** @type {(inputs: Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邮箱（如需回复）`)
};

const pt_br2_feedback_email_label = /** @type {(inputs: Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail, se quiser uma resposta`)
};

const es_feedback_email_label = /** @type {(inputs: Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correo electrónico, si quieres una respuesta`)
};

const fr_feedback_email_label = /** @type {(inputs: Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail, si vous voulez une réponse`)
};

const de_feedback_email_label = /** @type {(inputs: Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail, wenn du eine Antwort möchtest`)
};

const ru_feedback_email_label = /** @type {(inputs: Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Почта, если хотите получить ответ`)
};

const it_feedback_email_label = /** @type {(inputs: Feedback_Email_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email, se vuoi una risposta`)
};

/**
* | output |
* | --- |
* | "Email, if you want an answer" |
*
* @param {Feedback_Email_LabelInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const feedback_email_label = /** @type {((inputs?: Feedback_Email_LabelInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Email_LabelInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_feedback_email_label(inputs)
	if (locale === "pt-BR") return pt_br2_feedback_email_label(inputs)
	if (locale === "es") return es_feedback_email_label(inputs)
	if (locale === "fr") return fr_feedback_email_label(inputs)
	if (locale === "de") return de_feedback_email_label(inputs)
	if (locale === "ru") return ru_feedback_email_label(inputs)
	if (locale === "it") return it_feedback_email_label(inputs)
	return en_feedback_email_label(inputs)
});